import app from '@/app';
import templateUrl from './gapIdentification-detail.html';

/* @ngInject */
function Controller($controller, GapIdentification, ConstantSet, Principal, $timeout, AlertService, $state) {
	var $ctrl = this;

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: GapIdentification,
		type: 'gapIdentification'
	});

	// Override save to use 'entity.update.message' (async Plan module)
	$ctrl.save = () => {
		if (!$ctrl.readonly) {
			$ctrl.isSaving = true;
			const onSuccess = () => {
				AlertService.success('entity.update.message', {
					type: $ctrl.type,
					name: $ctrl.entity.name
				});
				$ctrl.isSaving = false;
				$state.go('^', {}, { reload: true });
			};
			const onError = error => {
				$ctrl.isSaving = false;
			};
			if ($ctrl.entity.id) {
				GapIdentification.update($ctrl.entity, onSuccess, onError);
			} else {
				GapIdentification.create($ctrl.entity, onSuccess, onError);
			}
		}
	};

  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})

	$ctrl.gapIdentificationSave = () => {
    $ctrl.entity.rateType = 'FIXED';
		$ctrl.entity.trafficGrowthRate = 1;
		$ctrl.entity.planHorizon = 1;
		$ctrl.entity.plantype = 'GAPS';
		$ctrl.entity.requestedYears = 0;
		$ctrl.save();
	};

	let debouncePromise = null;

	/** Debounced async search */
	$ctrl.queryConstantSets = query => {
		if (debouncePromise) $timeout.cancel(debouncePromise);

		$ctrl.loading = true;

		debouncePromise = $timeout(() => {
			return ConstantSet.query(
				{ query: query, size: 10, sort: 'name,asc' },
				data => {
					$ctrl.allConstantSets = data;
					$ctrl.loading = false;
				}
			).$promise;
		}, 300); // 300ms debounce

		return debouncePromise;
	};

	$ctrl.onRoadSelected = road => {
		$ctrl.entity.road = road;
		$ctrl.entity.headMilestone = road.headMilestone;
		$ctrl.entity.tailMilestone = road.tailMilestone;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaigns = null;
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaigns = null;
	};

	$ctrl.byOrganization = value =>
		$ctrl.entity.organization && value.organization.id == $ctrl.entity.organization.id;

	$ctrl.byOwner = value =>
		$ctrl.entity.organization && value.owner.id == $ctrl.entity.organization.id;
}

app.component('gapIdentificationDetail', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^gapIdentificationSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<'
	}
});
